import { Table } from '@chakra-ui/react'
import TouchRow from "./TouchRow"
import useStore from '../../../../store'
import { colors } from '../../../../utilities/colors'

export default function TouchesTable({ setSelectedTouch, dealerId }) {
  const touches = useStore((state) => state.touches)
  const fetchTouch = useStore((state) => state.fetchTouch)

  const handleClick = (touch) => {
    setSelectedTouch(touch)
    fetchTouch(dealerId, touch.id)
  }

  return(
    <Table.Root variant='simple'>
      <Table.Header>
        <Table.Row>
          <Table.ColumnHeader color={colors.grey300}>Type</Table.ColumnHeader>
          <Table.ColumnHeader color={colors.grey300}>Date</Table.ColumnHeader>
          <Table.ColumnHeader color={colors.grey300}>Touched By</Table.ColumnHeader>
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {touches && touches.map((touch) => (
          <TouchRow key={touch.id} touch={touch} onClick={() => handleClick(touch)} />
        ))}
      </Table.Body>
    </Table.Root>
  )
}